<template>
  <DataTable
  :items="tractSummaries"
  :headers="headers"
  :customCells="customCells"
  :hideHeader="true">
    <template #net-weight-tons="{item}">
      {{tonStringFromPounds(item.netWeight)}}
    </template>
    <template #net-volume="{item}">
      {{mbfStringFromBf(item.netVolume)}}
    </template>
    <template #body.append>
      <tr class="font-weight-bold">
        <td v-for="header in headers" :key="header.value" :class="`text-${header.align}`">{{totalsByColumn[header.value]}}</td>
      </tr>
    </template>
  </DataTable>
</template>

<script>
import { tractSummaryHeaders } from '@/headers/Cycles.js'
import { tonStringFromPounds, mbfStringFromBf } from '@/utils/NumericMutations.js'
export default {
  name: 'TractSummaries',

  components: {
    DataTable: () => import('@/components/core/table/DataTable.vue')
  },

  props: {
    tractSummaries: {
      type: Array,
      required: true
    }
  },

  computed: {
    hasVolumeData () {
      return this.tractSummaries.some(t => t.netVolume > 0 || t.grossVolume > 0)
    },

    headers () {
      return tractSummaryHeaders().getColumns()
        .filter(h => this.hasVolumeData || h.value !== 'netVolume')
    },

    totalsByColumn () {
      return {
        tractName: this.$t('totals'),
        loads: this.tractSummaries.reduce((a, b) => a + b.loads, 0),
        netWeight: tonStringFromPounds(this.tractSummaries.reduce((a, b) => a + b.netWeight, 0)),
        netVolume: mbfStringFromBf(this.tractSummaries.reduce((a, b) => a + b.netVolume, 0))
      }
    },

    customCells () {
      return [
        {
          slotName: 'net-weight-tons',
          value: 'netWeight'
        },
        {
          slotName: 'net-volume',
          value: 'netVolume'
        }
      ]
    }
  },
  methods: {
    tonStringFromPounds,
    mbfStringFromBf
  }
}
</script>
